/**
 * Secondary text links and buttons on the sign-in and Link pages ("Forgot
 * password?", Terms, "Back to login", "Sign in"). They take their height from a
 * text-xs/sm line box (16-20px), so:
 *  - an invisible ::after grows the hit area by 4px on every side (24px+,
 *    WCAG 2.5.8) without moving anything;
 *  - on a touch-first device (pointer: coarse) the target grows to 44px and the
 *    link is underlined at rest, because the hover underline that marks it as a
 *    link with a mouse never appears under a finger.
 * With a mouse (pointer: fine) the links look exactly as they did.
 */
export const AUTH_TEXT_LINK = 'relative inline-flex items-center after:absolute after:-inset-1 hover:underline pointer-coarse:min-h-11 pointer-coarse:underline pointer-coarse:underline-offset-2';
/** Red outline on a field that failed client-side validation (aria-invalid="true"). */
export const INVALID_FIELD = 'aria-invalid:border-red-500/70 aria-invalid:focus-visible:ring-red-500/40';
/**
 * Horizontal padding for full-width public chrome (the Link shell, the legal
 * pages). index.html opts into viewport-fit=cover, so in iPhone landscape the
 * page runs under the notch / Dynamic Island unless content keeps clear of it.
 */
export const SAFE_AREA_X = 'pl-[max(1rem,env(safe-area-inset-left))] pr-[max(1rem,env(safe-area-inset-right))]';
